var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "24px",
    viewBox: "0 0 19 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EC5E7D84-3FF4-47CE-B7FC-10A07465C35B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-650.000000, -479.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "doc",
    transform: "translate(650.000000, 479.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,1 L1,23 L18,23 L18,6.1486877 L15.3955468,3.79664063 L11.7097073,1 L1,1 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05175781,9.59716797 L13.9723424,9.59716797",
    id: "Path-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05175781,13.597168 L11.3813477,13.597168",
    id: "Path-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05175781,17.597168 L13.9723424,17.597168",
    id: "Path-36"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDocument);
export default __webpack_public_path__ + "static/media/ico_document.05d3b2b4d36291e8098251fcb246bf34.svg";
export { ForwardRef as ReactComponent };